import React, { useEffect, useState, useRef } from "react";
import "../favourites/favourites.css";
import { UserStore } from "../store/store";
import Anchor from "../Link/anchor";
import { deleteHistory } from "../javascript/function";

import SectionHeader from "../sectionHeader/sectionHeader";
import NotFound from "../notfound/notfound";
import LazyImg from "../lazy/lazy";
import { arrayWithProgress } from "../javascript/function";
// import InfiniteScroll from 'react-infinite-scroll-component';
// import Listloader from '../loader/listloader';
import { setWatchString, getWatchPlaylist } from "../api/core";
import Global from "../../global";
import CarouselContentLoader from "../loader/contentLoader";

const Watchlist = (props) => {
  const currentUser = UserStore.useState((s) => s.user);
  const [hist, setHist] = useState([]);
  const [phist, setPHist] = useState([]);
  //const [letmore,setLetMore] = useState(true);
  // const [totNum, settotNum] = useState(12);
  /* eslint-disable no-unused-vars */
  //const [limit,setLimit] = useState(12);
  //const [start,setStart] = useState(0);
  /* eslint-disable no-unused-vars */
  const [loading, isLoading] = useState(true);
  const [error, SetError] = useState(true);
  const mounted = useRef(false);

  /*    const fetchData = () =>
    {
      if(totNum===currentUser.WATCHHISTORY.length || totNum>=currentUser.WATCHHISTORY.length)
      {
        setLetMore(false);
      }
      else
      {
        
      
       let res = arrayWithProgress(currentUser.WATCHHISTORY,parseInt(limit+8),totNum,true);
       
       const newArray = [...hist, ...res];
       setHist(newArray);
       settotNum(totNum+hist.length);
       
       if(totNum===currentUser.WATCHHISTORY.length || totNum>=currentUser.WATCHHISTORY.length)
      {
        setLetMore(false);
      }
      

        

      }
     

    }
 */
  useEffect(() => {
    mounted.current = true;
    setHist(arrayWithProgress(currentUser.WATCHHISTORY, 50, 0, true));
    // setLetMore(false);
    const playlistDetail = async (id, key = Global.WHPL) => {
      /* eslint-disable no-unused-vars */
      const result = await getWatchPlaylist(key, id).then(
        (result) => {
          if (mounted.current) {
            setPHist(result.data);
            isLoading(false);
            SetError(false);
          }
        },
        (error) => {
          isLoading(false);
          SetError(true);
        }
      );
      /* eslint-disable no-unused-vars */
    };
    playlistDetail(
      setWatchString(arrayWithProgress(currentUser.WATCHHISTORY, 50, 0, false))
    );

    return () => {
      mounted.current = false;
    };
  }, [currentUser.WATCHHISTORY]);

  if (!loading && !error && phist !== null) {
    return (
      <div>
        <div style={{ paddingTop: "100px" }}>
          <SectionHeader
            title={
              phist === null || error || hist === null ? "" : "Watch History"
            }
            linkTitle={""}
            link={""}
            header={true}
          ></SectionHeader>
          <div
            className="landscapeList favourite"
            style={{ paddingTop: "30px" }}
          >
            <div className="container-fluid ">
              {phist !== null && !error && hist != null ? (
                phist.playlist.map((item, index) => (
                  <div className="list-item" key={index}>
                    <Anchor
                      className="slide-one slide-two"
                      to={
                        "/" +
                        props.match.params.AppId +
                        "/videoPage/" +
                        item.mediaid
                      }
                    >
                      <div className="slide-image">
                        <LazyImg
                          src={
                            `https://cdn.jwplayer.com/v2/media/` +
                            item.mediaid +
                            `/poster.jpg?width=480`
                          }
                          style={{
                            position: "absolute",
                            height: "100%",
                            width: "100%",
                          }}
                          orient={"landscape"}
                        />
                      </div>
                      <div className={"slide-content showed"}>
                        <h2>
                          {item.title}
                          <span
                            className="span"
                            onClick={(event) => {
                              deleteHistory(event, item);
                            }}
                          >
                            {" "}
                            <i className={"ri-close-fill"}></i>
                          </span>
                        </h2>
                      </div>
                      <div className="cwwrapper transparent">
                        <div
                          className="cwprogress"
                          style={{
                            width: hist.find((x) => x.video_id === item.mediaid)
                              ? hist.find((x) => x.video_id === item.mediaid)
                                  .progress + "%"
                              : "0%",
                          }}
                        ></div>
                      </div>
                    </Anchor>
                  </div>
                ))
              ) : (
                <NotFound
                  code={"Watch History"}
                  message={"No Data to Show"}
                ></NotFound>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    if (loading) {
      return <CarouselContentLoader></CarouselContentLoader>;
    } else {
      return (
        <NotFound
          code={"Watch History"}
          message={"No Data to Show"}
          {...props}
        ></NotFound>
      );
    }
  }
};

export default Watchlist;
